/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SeverityData } from './SeverityData';
import {
    SeverityDataFromJSON,
    SeverityDataFromJSONTyped,
    SeverityDataToJSON,
    SeverityDataToJSONTyped,
} from './SeverityData';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface MttxMetricsGraphResponse
 */
export interface MttxMetricsGraphResponse {
    /**
     * 
     * @type {boolean}
     * @memberof MttxMetricsGraphResponse
     */
    success?: boolean;
    /**
     * 
     * @type {{ [key: string]: { [key: string]: SeverityData; }; }}
     * @memberof MttxMetricsGraphResponse
     */
    data?: { [key: string]: { [key: string]: SeverityData; }; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof MttxMetricsGraphResponse
     */
    tenantContext?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof MttxMetricsGraphResponse
     */
    userTimezone?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof MttxMetricsGraphResponse
     */
    timezoneMetadata?: TimezoneMetadata;
}

/**
 * Check if a given object implements the MttxMetricsGraphResponse interface.
 */
export function instanceOfMttxMetricsGraphResponse(value: object): value is MttxMetricsGraphResponse {
    return true;
}

export function MttxMetricsGraphResponseFromJSON(json: any): MttxMetricsGraphResponse {
    return MttxMetricsGraphResponseFromJSONTyped(json, false);
}

export function MttxMetricsGraphResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MttxMetricsGraphResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'data': json['data'] == null ? undefined : json['data'],
        'tenantContext': json['tenantContext'] == null ? undefined : json['tenantContext'],
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
    };
}

export function MttxMetricsGraphResponseToJSON(json: any): MttxMetricsGraphResponse {
    return MttxMetricsGraphResponseToJSONTyped(json, false);
}

export function MttxMetricsGraphResponseToJSONTyped(value?: MttxMetricsGraphResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'data': value['data'],
        'tenantContext': value['tenantContext'],
        'userTimezone': value['userTimezone'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
    };
}

